var DealsMmSearch, HomepageCarousel, performSearch,
  slice = [].slice,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

HomepageCarousel = require('../../carousel/frontend/carousel');

performSearch = function(params) {
  var ref, search;
  if (params == null) {
    params = {};
  }
  if ((ref = this.xhr) != null) {
    ref.abort();
  }
  this.xhr = $.ajax({
    url: '/goods/deals/megamindhome',
    data: params
  });
  search = _.clone(Backbone.Events);
  this.xhr.done(_(search.trigger).bind(search, 'success'));
  this.xhr.fail((function(_this) {
    return function(xhr, textStatus) {
      if (!textStatus === "abort") {
        return _(search.trigger).bind(search, 'error');
      }
    };
  })(this));
  this.xhr.always(function() {
    search.trigger.apply(search, ['complete'].concat(slice.call(arguments)));
    return search.off();
  });
  return {
    on: _(search.once).bind(search)
  };
};

module.exports = DealsMmSearch = (function() {
  function DealsMmSearch(options) {
    var datetime, dealsSearch, megamindPreview, ref;
    if (options == null) {
      options = {};
    }
    this._triggerSuccessHandler = bind(this._triggerSuccessHandler, this);
    this._triggerErrorHandler = bind(this._triggerErrorHandler, this);
    this._events = _.extend({}, Backbone.Events);
    this.inNewHomepage = options.inNewHomepage, this.carouselConfig = options.carouselConfig, this.homeWidgetPreview = options.homeWidgetPreview, this.showFreeShippingModal = options.showFreeShippingModal;
    if (this.homeWidgetPreview) {
      ref = this.homeWidgetPreview, datetime = ref.datetime, megamindPreview = ref.megamindPreview;
    }
    if (datetime && megamindPreview) {
      this.params = {
        datetime: datetime,
        megamindPreview: megamindPreview
      };
    }
    dealsSearch = performSearch(this.params);
    dealsSearch.on('error', this._triggerErrorHandler);
    dealsSearch.on('success', this._triggerSuccessHandler);
    null;
  }

  DealsMmSearch.prototype.on = function(event, callback) {
    return this._events.on(event, callback);
  };

  DealsMmSearch.prototype._triggerErrorHandler = function() {
    this._events.trigger('error');
    return this._events.stopListening();
  };

  DealsMmSearch.prototype._triggerSuccessHandler = function(arg, textStatus) {
    var dealIdList, deals, ref;
    ref = arg != null ? arg : {}, deals = ref.deals, dealIdList = ref.dealIdList;
    if (textStatus !== 'success') {
      return this._triggerErrorHandler();
    } else {
      this._events.trigger('success', deals, dealIdList);
      Groupon.Utils.lazyLoadImages();
      if (this.inNewHomepage) {
        new HomepageCarousel({
          carouselConfig: this.carouselConfig,
          showFreeShippingModal: this.showFreeShippingModal
        });
      }
      return this._events.stopListening();
    }
  };

  return DealsMmSearch;

})();

//# sourceMappingURL=data:application/json;base64,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
